var DealsMmSearch, HomepageCarousel, performSearch,
  slice = [].slice,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

HomepageCarousel = require('../../carousel/frontend/carousel');

performSearch = function(params) {
  var ref, search;
  if (params == null) {
    params = {};
  }
  if ((ref = this.xhr) != null) {
    ref.abort();
  }
  this.xhr = $.ajax({
    url: '/goods/deals/megamindhome',
    data: params
  });
  search = _.clone(Backbone.Events);
  this.xhr.done(_(search.trigger).bind(search, 'success'));
  this.xhr.fail((function(_this) {
    return function(xhr, textStatus) {
      if (!textStatus === "abort") {
        return _(search.trigger).bind(search, 'error');
      }
    };
  })(this));
  this.xhr.always(function() {
    search.trigger.apply(search, ['complete'].concat(slice.call(arguments)));
    return search.off();
  });
  return {
    on: _(search.once).bind(search)
  };
};

module.exports = DealsMmSearch = (function() {
  function DealsMmSearch(options) {
    var datetime, dealsSearch, megamindPreview, ref;
    if (options == null) {
      options = {};
    }
    this._triggerSuccessHandler = bind(this._triggerSuccessHandler, this);
    this._triggerErrorHandler = bind(this._triggerErrorHandler, this);
    this._events = _.extend({}, Backbone.Events);
    this.inNewHomepage = options.inNewHomepage, this.carouselConfig = options.carouselConfig, this.homeWidgetPreview = options.homeWidgetPreview, this.showFreeShippingModal = options.showFreeShippingModal;
    if (this.homeWidgetPreview) {
      ref = this.homeWidgetPreview, datetime = ref.datetime, megamindPreview = ref.megamindPreview;
    }
    if (datetime && megamindPreview) {
      this.params = {
        datetime: datetime,
        megamindPreview: megamindPreview
      };
    }
    dealsSearch = performSearch(this.params);
    dealsSearch.on('error', this._triggerErrorHandler);
    dealsSearch.on('success', this._triggerSuccessHandler);
    null;
  }

  DealsMmSearch.prototype.on = function(event, callback) {
    return this._events.on(event, callback);
  };

  DealsMmSearch.prototype._triggerErrorHandler = function() {
    this._events.trigger('error');
    return this._events.stopListening();
  };

  DealsMmSearch.prototype._triggerSuccessHandler = function(arg, textStatus) {
    var dealIdList, deals, ref;
    ref = arg != null ? arg : {}, deals = ref.deals, dealIdList = ref.dealIdList;
    if (textStatus !== 'success') {
      return this._triggerErrorHandler();
    } else {
      this._events.trigger('success', deals, dealIdList);
      Groupon.Utils.lazyLoadImages();
      if (this.inNewHomepage) {
        new HomepageCarousel({
          carouselConfig: this.carouselConfig,
          showFreeShippingModal: this.showFreeShippingModal
        });
      }
      return this._events.stopListening();
    }
  };

  return DealsMmSearch;

})();

//# sourceMappingURL=data:application/json;base64,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
